import { CrudModel } from "./_crud";

export class blockedClientModel extends CrudModel {
	constructor() {
		super("admin/blocked_client", [], []);
	}

	async getBlockedClients(params?: any) {
		return this.getParam(params);
	}

	async getOneBlockedClient(id: string, params?: any) {
		return this.get(id, params);
	}
}

export default new blockedClientModel();
